module.exports = "//static.hsappstatic.net/react-codemirror/static-1.9277/theme/hubspot-canvas-dark.sass"